/*
 *  Author: DL
 *  Date: 2020-12-07 11:44:03
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-07 11:53:14
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React from 'react';
import FmapContext from '@/hook/useFmapContext';

const Provider = FmapContext.Provider;

export default function(props) {
    const { value = {}, children } = props;

    return <Provider value={{ ...value }}>{children}</Provider>;
}
